import { IList, IListElement, spError, spLogTags } from '@eventr/common'

import { StateCreator } from 'zustand'
import { Lists } from '../data/api'
import { BoundStore } from './bound.store'

export interface ListSlice {
    allLists: IList[]
    fetchList: (listTypes: string) => IList | null
    fetchLists: (listTypes: string[]) => IList[] | null
    fetchAllLists: () => Promise<IList[]>
}

export const createListSlice: StateCreator<
    BoundStore,
    [['zustand/devtools', never]],
    [],
    ListSlice
> = (set, get) => ({
    allLists: [],
    fetchList: (listType: string): IList | null => {
        const allLists = get().allLists
        const list = allLists.find(
            (list) => list.listType.toString() === listType
        )

        if (list) {
            return list
        } else {
            spLogTags('No list found for type: ' + listType, ['List'])
        }

        return null
    },
    fetchLists: (listTypes: string[]): IList[] | null => {
        const allLists = get().allLists
        const filteredLists = allLists.filter((list) =>
            listTypes.includes(list.listType.toString())
        )

        if (filteredLists) {
            return filteredLists
        } else {
            spLogTags('No lists found for types: ' + listTypes, ['List'])
        }

        return null
    },
    fetchAllLists: async (): Promise<IList[]> => {
        try {
            const fetchedLists = (await Lists.fetchAllLists()) as IList[]
            const parsedLists = fetchedLists.map((list) => {
                return {
                    ...list,
                    elements: JSON.parse(
                        list.elements.toString()
                    ) as IListElement[],
                }
            })
            set({ allLists: parsedLists }, false, 'fetchAllLists')
            return fetchedLists
        } catch (error) {
            spError('Error fetching lists', error)
            return []
        }
    },
})
